import React, { useContext, useReducer, createContext } from 'react'
import { ApolloProvider } from '@apollo/react-hooks'

import initialState from './initial'
import reducer from './reducers'
import client from './apollo'
import { IAppState } from 'models'

// interface AppInterface {
// initialState: AppState
// reducer: React.Reducer<AppState, React.ReducerAction<any>>
// }

// export const firebaseApp = firebase.initializeApp({
// 	apiKey: 'AIzaSyD3BQ3mNupKYAYNyVMAIUEkvIIWuTMUxMM',
// 	authDomain: 'cv30dev-feda5.firebaseapp.com',
// 	databaseURL: 'https://cv30dev-feda5.firebaseio.com',
// 	projectId: 'cv30dev-feda5',
// 	storageBucket: 'cv30dev-feda5.appspot.com',
// 	messagingSenderId: '956898530395',
// 	appId: '1:956898530395:web:04a62746a7d8cbf9',
// })

const AppContext: React.Context<[IAppState, React.Dispatch<any>]> =
	createContext<any>(null)

export const AppProvider: React.FunctionComponent<{}> = ({ children }) => {
	return (
		<ApolloProvider client={client}>
			<AppContext.Provider value={useReducer(reducer, initialState)}>
				{children}
			</AppContext.Provider>
		</ApolloProvider>
	)
}

// new version of store
interface IStoreValue {
	children: any
	keys: any
	// TODO: Update the interface with proper types
}

export const StoreValue = ({ children, keys = [] }: IStoreValue) => {
	// Destructure both state and dispatch from context
	const [state, storeDispatch] = useContext(AppContext)

	const result = keys.reduce((acc: { [key: string]: any }, item: string) => {
		const [path, alias] = item.split('|')
		const pathParts = path.split('.')
		const keyName = alias || pathParts[pathParts.length - 1]

		let value = state
		for (const part of pathParts) {
			if (value == null) {
				acc[keyName] = null
				break
			}

			if (part.match(/^\d+$/)) {
				const index = parseInt(part, 10)
				value = Array.isArray(value) ? value[index] : undefined
			} else {
				value = value[part]
			}
		}

		acc[keyName] = value ?? null
		return acc
	}, {})

	// Add storeDispatch to props if requested
	if (keys.includes('storeDispatch')) {
		result.storeDispatch = storeDispatch
	}

	const enhancedChildren = React.Children?.map(children, child => {
		if (React.isValidElement(child)) {
			return React.cloneElement(child, result)
		}
		return child
	})

	return <>{enhancedChildren}</>
}

export const useStoreValue = () => useContext(AppContext)
